import { motion } from "framer-motion";

/**
 * Certain states fetch data:
 * - SELECT_FAVORITE: teams and team colors
 * - SELECT_FOLLOWS: teams
 * - SELECT_PLAYER_FOLLOWS: team's roster
 *
 * We will query Midfield using Axios.
 * This config will allow us to use the appropriate server per environment
 * in conjunction with the `env` prop exposed on components.
 */
export var DEFAULT_ENV = "production";
export var ENV_CONFIG = {
  development: {
    midfield: "https://data-graph-dev.mlb.com/graphql",
    typeahead: "https://type-ahead.bdata-gcp-npd.mlbinfra.net/api/v1/typeahead/suggestions/"
  },
  qa: {
    midfield: "https://data-graph-qa.mlb.com/graphql",
    typeahead: "https://type-ahead.bdata-gcp-npd.mlbinfra.net/api/v1/typeahead/suggestions/"
  },
  beta: {
    midfield: "https://data-graph-beta.mlb.com/graphql",
    typeahead: "https://type-ahead.bdata-gcp-npd.mlbinfra.net/api/v1/typeahead/suggestions/"
  },
  production: {
    midfield: "https://data-graph.mlb.com/graphql",
    typeahead: "https://typeahead.mlb.com/api/v1/typeahead/suggestions/"
  }
};

/**
 * Props that will be applied to each FieldPassState container to provide consistent animation when changing between states
 */
export var ANIMATION_PROPS = {
  animate: {
    opacity: 1
  },
  as: motion.div,
  initial: {
    opacity: 0
  }
};

/**
 * Given a human-readable GraphQL query, minify and encode for use as query parameter
 * 1. Remove newline characters
 * 2. Replace instances of multiple whitespace with a single whitespace
 * 3. encodeURI
 */
export var minifyQuery = function minifyQuery() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var minified = (query === null || query === void 0 ? void 0 : query.replace(/[\n\r]/g, "").replace(/\s\s+/g, " ")) || "";
  return encodeURI(minified);
};